import { lruCache } from '../../utils/lruCache';
import { ResponseError } from '../../errors';
import { IApplicationContext } from '../../types/applicationContext';
import {
  TGetRegionExtensionItemResponse,
  fetchGetRegionExtensionItem,
} from '../../repositories/countryside-region-extension/v1/get-region-extension-item';

interface IFetchExtensionRegionParams {
  regionId: number;
}

const fetchExtensionRegion = async (
  { httpApi, logger }: IApplicationContext,
  parameters: IFetchExtensionRegionParams,
) => {
  try {
    const extensionRegionData: TGetRegionExtensionItemResponse = await fetchGetRegionExtensionItem({
      httpApi,
      parameters,
    });

    if (extensionRegionData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchExtensionRegion',
        message: extensionRegionData.response.message || 'unknown error',
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: extensionRegionData.response.errors as any,
        },
      });
    }

    return extensionRegionData.response.regionItem;
  } catch (error) {
    logger.warning(error, { degradation: 'Расширение региона' });

    return null;
  }
};

const fetchExtensionRegionWithCache = lruCache(fetchExtensionRegion, { key: 'extensionRegion' });

export const fetchExtensionRegionCached = (context: IApplicationContext, parameters: IFetchExtensionRegionParams) => {
  return fetchExtensionRegionWithCache(`extensionRegion.${parameters.regionId}`, context, context, parameters);
};
